"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    UnstakeInfo: {
      amount: 'Balance',
      blockNumber: 'u32',
      eraIndex: 'Option<u32>'
    },
    StakingSettlementKind: {
      _enum: ['Reward', 'Slash']
    },
    MatchingLedger: {
      totalStakeAmount: 'Balance',
      totalUnstakeAmount: 'Balance'
    }
  }
};
exports.default = _default;